import React from "react";
import "./CardEightScreen.css";
import Footer from "../Footer/Footer";
import mixpanel from "../../mixpanel";

interface CardEightScreenProps {
  onCall?: () => void;
  onResources?: () => void;
}

export default function CardEightScreen({ onCall, onResources }: CardEightScreenProps) {
  return (
    <div className="card-eight-screen">
      <div className="card-eight-content">
        <h1 className="card-eight-title">Պատրա՞ստ եք քայլեր կատարել, բայց պետք է առաջնային խթան</h1>

        <div className="card-eight-cta-section">
          <button className="card-eight-cta" onClick={() => { mixpanel.track("cta_schedule_meeting_clicked"); onCall?.(); }}>
            Կազմակերպել օնլայն հանդիպում
          </button>
        </div>

        <div className="card-eight-resources">
          <button className="card-eight-resources-link" onClick={() => { mixpanel.track("cta_resources_page_clicked"); onResources?.(); }}>
            Անցնել ռեսուրսների էջ
          </button>
        </div>
      </div>
              <Footer></Footer>
    </div>
  );
}
